const extraGetEvent = (event) => {
  return event;
};

export default extraGetEvent;
